<template>
  <div style="text-align: left">
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item>
        <el-row>
          <el-col :span="1">时间</el-col>
          <el-col :span="10">
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-col>

          <el-col :span="1" :offset="2">状态</el-col>
          <el-col :span="6">
            <el-select v-model="form.status" placeholder="请选择">
              <el-option
                v-for="item in statuses"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :offset="2" :span="2">
            <el-button type="primary" @click="onQuery"><i class="el-icon-search"></i> 查询</el-button>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>

    <el-table
      :data="payList"
      border
      style="width: 100%">
      <el-table-column
        prop="id"
        label="编号">
      </el-table-column>
      <el-table-column
        label="用户">
        <template slot-scope="scope">
          <router-link :to="{path: '/user/details', query: {id: scope.row.customer}}">{{scope.row.customer}}</router-link>
        </template>
      </el-table-column>
      <el-table-column
        label="商家">
        <template slot-scope="scope">
          <router-link v-if="scope.row.trade > 0" :to="{path: '/provider/details', query: {id: scope.row.trade}}">{{scope.row.trade}}</router-link>
          <div v-else>#</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="amount"
        label="金额">
        <template slot-scope="scope">
          {{ scope.row.amount / 100 }}元
        </template>
      </el-table-column>
      <el-table-column
        prop="typeStr"
        label="类型">
      </el-table-column>
      <el-table-column
        prop="statusStr"
        label="状态">
      </el-table-column>
      <el-table-column
        prop="et"
        label="时间">
      </el-table-column>
      <el-table-column
        label="#">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status == 2" @click="onDetailQuery(scope.row.id)" type="success"><i class="el-icon-sugar"></i> 分润明细</el-button>

          <el-popconfirm
            v-else-if="scope.row.status == 3 && user !== 'reader'"
            confirm-button-text='确认'
            cancel-button-text='取消'
            icon="el-icon-info"
            icon-color="red"
            title="确认要重置当前订单的支付状态吗？"
            @confirm="onResetPayStatus(scope.row.id)">
            <el-button slot="reference" type="danger"><i class="el-icon-open"></i> 重置状态</el-button>
          </el-popconfirm>
          <div v-else>#</div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="pagination"
      v-if="totalElements > 0"
      background
      layout="prev, pager, next"
      @current-change="handlePageChange"
      :current-page.sync="form.page"
      :page-size="form.pageSize"
      :total="totalElements">
    </el-pagination>


    <el-dialog title="分润明细" :visible.sync="showShareDetails">
      <el-table :data="shareDetails">
        <el-table-column property="customerId" label="用户id"></el-table-column>
        <el-table-column property="providerId" label="商家id"></el-table-column>
        <el-table-column property="originalAmount" label="支付金额"></el-table-column>
        <el-table-column property="shareRatio" label="分润比例"></el-table-column>
        <el-table-column property="shareMoney" label="分润金额"></el-table-column>
        <el-table-column property="comment" label="说明"></el-table-column>
      </el-table>
    </el-dialog>
  </div>

</template>

<script>
import * as api from "@/js/api.js";

export default {
  name: "PayList",
  data() {
    return {
      showShareDetails: false,
      shareDetails: [],
      payList: [],
      dateRange: [],
      form: {
        start: null,
        end: null,
        id: null,
        status: 2,
        page: 1,
        pageSize: 50
      },
      statuses: [{name: '未处理', value: 0}, {name: '已支付', value: 1}, {name: '已分润', value: 2}, {name: '支付失败', value: 3}],
      totalElements: 0,
      user: this.$store.state.CurrentUser,
    }
  },

  methods: {
    handlePageChange() {
      this.onQuery()
    },

    onDetailQuery(id) {
      this.showShareDetails = true
      let params = {
        payOrderId: id
      }

      api.payDetails(params).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('数据请求出错')
        } else {
          this.shareDetails = result.data
        }
      })
    },

    onResetPayStatus(id) {
      let params = {
        payId: id
      }

      api.resetPayStatus(params).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('操作出错')
        } else {
          this.$message.success('操作成功')
        }
      })

    },

    onQuery() {
      let query = this.form
      if (this.dateRange && this.dateRange[0]) {
        query.start = this.dateRange[0] + " 00:00:00"
        query.end = this.dateRange[1] + " 23:59:59"
      } else {
        query.start = null
        query.end = null
      }

      api.payQuery(query).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('请求区域信息出错');
        } else {
          this.payList = result.data.content
          this.totalElements = result.data.totalElements
        }
      })
    },
  },
  mounted() {
    this.onQuery()
  },
}
</script>

<style scoped>

.pagination {
  margin-top: 15px;
}

</style>



// WEBPACK FOOTER //
// src/pages/pay/PayList.vue